var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 96 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480 741.022q18.524 0 31.056-12.531 12.531-12.532 12.531-31.056 0-18.525-12.531-31.056-12.532-12.531-31.056-12.531t-31.056 12.531q-12.531 12.531-12.531 31.056 0 18.524 12.531 31.056 12.532 12.531 31.056 12.531Zm-41.913-161.674h83.826v-205.5h-83.826v205.5ZM480 984.37q-142.532-35.672-235.331-162.562-92.8-126.89-92.8-281.808V290.39L480 167.63l328.131 122.76V540q0 154.918-92.8 281.808Q622.532 948.698 480 984.37Zm0-95q102.326-34.435 169.728-132 67.402-97.566 67.402-217.259V353.152L480 264.348l-237.13 88.92V540q0 119.804 67.402 217.37 67.402 97.565 169.728 132Zm0-312.892Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarm);
export default __webpack_public_path__ + "static/media/garm.05a215c9.svg";
export { ForwardRef as ReactComponent };